<template>
  <div v-if="ip_address_info" class="ip_address_info">
    <div class="ip_address_info__left">
      <div class="ip_address_info__left__wrap" ref="content">
        <div class="main_info" ref="main_info">
          <div class="row">
            <div class="col-md-4">
              <fg-input
                  v-model="ip_address_info.name"
                  type="text"
                  :label="translate('ip_profile.name')"
                  :placeholder="translate('ip_profile.name')"
              />
            </div>
            <div class="col-md-4">
              <fg-input
                  v-model="ip_address_info.short_name"
                  type="text"
                  :label="translate('ip_profile.name_short')"
                  :placeholder="translate('ip_profile.name_short')"
              />
            </div>
            <div class="col-md-4">
              <div class="form_group">
                <label> {{ translate('ip_profile.server') }} </label>
                <tree-select
                    v-model="ip_address_info.server_id"
                    :options="server_list"
                    :multiple="false"
                    :close-on-select="true"
                    :clearable="false"
                    :hide-selected="true"
                    :max-height="165"
                    :placeholder="translate('ip_profile.server')"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <fg-input
                  v-model="ip_address_info.ip"
                  type="text"
                  label="IP"
                  placeholder="IP"
              />
            </div>
            <div class="col-md-2">
              <fg-input
                  v-model="ip_address_info.min"
                  type="text"
                  label="min"
                  placeholder="min"
              />
            </div>
            <div class="col-md-2">
              <fg-input
                  v-model="ip_address_info.max"
                  type="text"
                  label="max"
                  placeholder="max"
              />
            </div>

            <div class="col-md-2">
              <fg-input
                  v-model="ip_address_info.ports"
                  type="text"
                  label="ports"
                  placeholder="ports"
              />
            </div>
            <div class="col-md-2">
              <fg-input
                  v-model="ip_address_info.by_ports"
                  type="text"
                  label="by ports"
                  placeholder="by ports"
              />
            </div>
          </div>

          <div class="row" v-if="ip_address_info.time_life">
            <div class="col-md-12">
              <p>{{ translate("server.reservation_time_ip")}}: {{ ip_address_info.time_life }}</p>
            </div>
          </div>
        </div>

        <div class="line text-center buttons">
          <span
              v-if="has_changes"
              class="btn btn-info btn-fill btn-wd"
              @click.prevent="edit_ip_address"
          >
            {{ translate("btn.edit") }}
          </span>
        </div>
      </div>

    </div>

    <div class="ip_address_info__right">
      <Summary type="ip_address" :info="ip_address_info" :view_history="false" />
    </div>
  </div>

</template>
<script>
import Summary from "components/UIComponents/Summary/Summary.vue";

const fields_to_check = ["name", "short_name", "server_id", "ip", "min", "max", "ports", "by_ports"];

export default {
  name: 'IP_addressInfo',
  components: {
    Summary
  },

  props: {
    ip_address: {
      type: Object,
      required: true
    },
  },

  data() {
    return {
      ip_address_info: {},
      servers: []
    }
  },

  created() {
    this.ip_address_info = JSON.parse(JSON.stringify(this.ip_address))
  },

  activated() {
    this.ip_address_info = JSON.parse(JSON.stringify(this.ip_address))
  },

  computed: {
    server_list() {
      let server_list = []
      for (let server of this.$store.getters.getServerList) {
        server_list.push({id: server.id, label: server.name})
      }
      return server_list
    },
    has_changes() {
      let ip_address = fields_to_check.reduce((obj, key) => {
        obj[key] = this.ip_address[key];
        return obj;
      }, {});

      let ip_address_info = fields_to_check.reduce((obj, key) => {
        obj[key] = this.ip_address_info[key];
        return obj;
      }, {});

      return JSON.stringify(ip_address) !== JSON.stringify(ip_address_info);
    }
  },

  watch: {
    ip_address(){
      this.ip_address_info = JSON.parse(JSON.stringify(this.ip_address))
    }
  },

  methods: {
    edit_ip_address() {
      let params = fields_to_check.reduce((obj, key) => {
        obj[key] = this.ip_address_info[key];
        return obj;
      }, {});

      this.$http.v1.updateIPS(this.ip_address_info.id, params, (response) => {
        this.global_notify('info', this.translate('profile_saved'))
        this.$emit("update_ip_info", response.data)
      })
    },
  }
}

</script>

<style lang='scss' scoped>
.ip_address_info {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  overflow: auto;

  @media (max-width: 991px) {
    flex-direction: column;
  }

  &__left {
    width: 70%;
    height: 100%;
    padding-right: 10px;
    @media (max-width: 991px) {
      width: 100%;
      height: auto;
    }

    .form_select{
      .form-control {
        width: 100%;
      }
    }

    .buttons {
      margin-top: 10px;
      .btn{
        margin-right: 10px;
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }

  &__right {
    width: 30%;
    height: 100%;
    @media (max-width: 991px) {
      width: 100%;
      height: auto;
    }
  }
}
</style>
